const text = new TextDecoder('ascii');
/** Reads only the fields needed before re-encoding. Re-encoded variants contain no EXIF. */
export function extractJpegMetadata(bytes) {
    if (bytes[0] !== 0xff || bytes[1] !== 0xd8)
        return { orientation: 1, hadGps: false };
    for (let offset = 2; offset + 4 < bytes.length;) {
        if (bytes[offset] !== 0xff)
            break;
        const marker = bytes[offset + 1];
        const length = (bytes[offset + 2] << 8) | bytes[offset + 3];
        if (marker === 0xe1 &&
            text.decode(bytes.subarray(offset + 4, offset + 10)) === 'Exif\u0000\u0000') {
            return parseTiff(bytes, offset + 10, offset + 2 + length);
        }
        if (length < 2)
            break;
        offset += 2 + length;
    }
    return { orientation: 1, hadGps: false };
}
function parseTiff(bytes, start, end) {
    const little = text.decode(bytes.subarray(start, start + 2)) === 'II';
    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const u16 = (at) => view.getUint16(at, little);
    const u32 = (at) => view.getUint32(at, little);
    const firstIfd = start + u32(start + 4);
    if (firstIfd < start || firstIfd + 2 > end)
        return { orientation: 1, hadGps: false };
    let orientation = 1;
    let hadGps = false;
    let capturedAt;
    const entries = Math.min(u16(firstIfd), 512);
    for (let index = 0; index < entries; index += 1) {
        const entry = firstIfd + 2 + index * 12;
        if (entry + 12 > end)
            break;
        const tag = u16(entry);
        if (tag === 0x0112) {
            const value = u16(entry + 8);
            if (value >= 1 && value <= 8)
                orientation = value;
        }
        if (tag === 0x8825)
            hadGps = u32(entry + 8) !== 0;
        if (tag === 0x9003 || tag === 0x0132) {
            const count = u32(entry + 4);
            const valueOffset = count <= 4 ? entry + 8 : start + u32(entry + 8);
            if (valueOffset >= start && valueOffset + count <= end) {
                const raw = text
                    .decode(bytes.subarray(valueOffset, valueOffset + count))
                    .replace(/\0/g, '');
                const match = /^(\d{4}):(\d{2}):(\d{2}) (\d{2}):(\d{2}):(\d{2})$/.exec(raw);
                if (match)
                    capturedAt = `${match[1]}-${match[2]}-${match[3]}T${match[4]}:${match[5]}:${match[6]}`;
            }
        }
    }
    return { orientation, hadGps, ...(capturedAt ? { capturedAt } : {}) };
}
export function canonicalizeCaptureMetadata(input) {
    return {
        orientation: input.extracted.orientation,
        hadGps: input.extracted.hadGps,
        sourceMimeType: input.sourceMimeType,
        sourceBytes: input.sourceBytes,
        ...(input.extracted.capturedAt ? { capturedAt: input.extracted.capturedAt } : {}),
        ...(input.width === undefined ? {} : { sourceWidth: input.width }),
        ...(input.height === undefined ? {} : { sourceHeight: input.height }),
    };
}
